import React, { useMemo } from "react";

import { Order } from "../../../../../../../services";
import { useAppContext } from "../../../../../../../context";
import { CellContentRoot } from "..";

const ExecutingStageWithClientsTimeCellContent: React.FC<
	ExecutingStageWithClientsTimeCellContent.Props
> = ({ item }) => {
	const { dateFns } = useAppContext();

	const content = useMemo(() => {
		const timestamp = item?.executingStages?.with_clients?.timestamp;
		if (!timestamp || !dateFns) return "";
		return dateFns.formatTime(timestamp, {
			isTimezone: true,
			formatTime: "HH:mm:ss",
		});
	}, [item?.executingStages?.with_clients?.timestamp, dateFns]);

	return (
		<CellContentRoot alignItems="center" h="100%" w="100%">
			{content}
		</CellContentRoot>
	);
};

declare namespace ExecutingStageWithClientsTimeCellContent {
	interface Props {
		item: Order.Model;
	}
}

export default ExecutingStageWithClientsTimeCellContent;
